import { Injectable } from '@angular/core';
import { LinhaRota } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha-rota.entity';
import { Parada } from '@tivic-team/manager-ts/dist/mob/entities/parada/parada.entity';
import { HttpDelete, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environment-v3';
import { LinhaRotaDTO } from '../../model/dtos/mob/linha-rota.dto';
import { ParadaTabelaHorariosDTO } from '../../model/dtos/mob/para-tabela-horarios.dto';
import { ApiController } from '../api-controller.interface';

@Injectable()
export class LinhaRotaController implements ApiController<LinhaRota>{

	constructor() { }

	find(filtros?: IFilter): Promise<LinhaRota[]> {
		let request = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/linharotas',
					environment: environmentv3,
					filter: filtros
				}),
			}),
			new HttpResponse(new Array<LinhaRota>())
		);
		return request.call();
	}

	create(entity: LinhaRota): Promise<LinhaRota> {
		let request = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/linharotas',
					environment: environmentv3
				}),
				data: new JSONData(entity)
			}),
			new HttpResponse(
				new LinhaRota()
			)
		);
		return request.call();
	}

	update(entity: LinhaRota): Promise<LinhaRota> {
		let request = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/linharotas/:cdLinha/:cdRota',
					environment: environment,
					pathParams: new JSONData({
						cdLinha: entity.cdLinha, cdRota: entity.cdRota
					})
				}),
				data: new JSONData(entity)
			}),
			new HttpResponse(
				new LinhaRota()
			)
		);
		return request.call();
	}

	getRota(cdLinha: number, cdRota: number): Promise<LinhaRota> {
		let request = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/linharotas/:cdLinha/:cdRota',
					environment: environmentv3,
					pathParams: new JSONData({
						cdLinha: cdLinha,
						cdRota: cdRota
					})
				}),
			}),
			new HttpResponse(new LinhaRota())
		);
		return request.call();
	}

	get(id: number): Promise<LinhaRota> {
		throw new Error('Method not implemented.');
	}

	async createLinhaRotaDTO(linhaRotaDTO: LinhaRotaDTO): Promise<LinhaRota> {
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/linharotas/linhaRotaDTO',
					environment: environment
				}),
				data: new JSONData(linhaRotaDTO)
			}),
			new HttpResponse(
				new LinhaRota()
			)
		);
		return await quark.call();
	}

	async updateLinhaRotaDTO(linhaRotaDTO: LinhaRotaDTO): Promise<LinhaRota> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/linharotas/linhaRotaDTO/:cdLinha/:cdRota',
					environment: environment,
					pathParams: new JSONData({ cdLinha: linhaRotaDTO.cdLinha, cdRota: linhaRotaDTO.cdRota })
				}),
				data: new JSONData(linhaRotaDTO)
			}),
			new HttpResponse(
				new LinhaRota()
			)
		);
		return await quark.call();
	}

	async getParadasRota(cdLinha: number, cdRota: number): Promise<Array<ParadaTabelaHorariosDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/linharotas/:cdLinha/:cdRota/paradas',
					environment: environment,
					pathParams: new JSONData({
						cdLinha,
						cdRota
					})
				}),
			}),
			new HttpResponse(
				new Array<Parada>()
			)
		);
		return await quark.call();
	}

	async getRotasLinha(idLinha: number, cdRota: number): Promise<Array<LinhaRotaDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/linharotas/:cdRota/:idLinha/rotas',
					environment: environment,
					pathParams: new JSONData({
						idLinha,
						cdRota,
					})
				}),
			}),
			new HttpResponse(
				new Array<LinhaRotaDTO>()
			)
		);
		return await quark.call();
	}

	async remove(cdLinha: number, cdRota: number): Promise<LinhaRota> {
		let quark = new Quark(
			new HttpDelete({
				url: new Url({
					id: 'mob/linharotas/:cdLinha/:cdRota',
					environment: environmentv3,
					pathParams: new JSONData({ cdLinha, cdRota })
				}),
			}),
			new HttpResponse(
				new LinhaRota()
			)
		);
		return await quark.call();
	}

	async inactivate(linhaRota: LinhaRota): Promise<LinhaRota> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/linharotas/inactivate',
					environment: environmentv3,
				}),
				data: new JSONData(linhaRota)
			}),
			new HttpResponse(
				new LinhaRota()
			)
		);
		return await quark.call();
	}

	async activate(linhaRota: LinhaRota): Promise<LinhaRota> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/linharotas/activate',
					environment: environmentv3,
				}),
				data: new JSONData(linhaRota)
			}),
			new HttpResponse(
				new LinhaRota()
			)
		);
		return await quark.call();
	}

}